import { useEffect, useState } from "react";

// Reactive read of the light/dark toggle (`<html class="light">`, see lib/theme.js) for
// components that need to pick actual color values in JS rather than relying on the
// `html.light ...` CSS-override cascade — needed wherever a surface uses inline styles
// (gradients, hex literals) that a stylesheet rule can never win against.
export default function useTheme() {
  const [light, setLight] = useState(() => document.documentElement.classList.contains("light"));
  useEffect(() => {
    const obs = new MutationObserver(() => setLight(document.documentElement.classList.contains("light")));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return light ? "light" : "dark";
}
